<template>
  <div>
    <el-dialog title="登录轨迹" :visible.sync="dialogVisible" width="980px">
      <div class="summary-grid">
        <div class="summary-item">登录次数：{{ summary.login_count || 0 }}</div>
        <div class="summary-item">设备数：{{ summary.device_count || 0 }}</div>
        <div class="summary-item">IP数：{{ summary.ip_count || 0 }}</div>
        <div class="summary-item">OAID数：{{ summary.oaid_count || 0 }}</div>
        <div class="summary-item">渠道数：{{ summary.channel_count || 0 }}</div>
        <div class="summary-item">首次登录：{{ formatTime(summary.first_login_time) }}</div>
        <div class="summary-item">最近登录：{{ formatTime(summary.last_login_time) }}</div>
      </div>

      <div class="filter-grid">
        <el-input v-model.trim="queryForm.ip" size="small" placeholder="搜索IP" />
        <el-input v-model.trim="queryForm.phone_id" size="small" placeholder="搜索设备ID" />
        <el-input v-model.trim="queryForm.oaid" size="small" placeholder="搜索OAID" />
        <el-input v-model.trim="queryForm.channel_id" size="small" placeholder="搜索渠道ID" />
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          size="small"
          value-format="timestamp"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleTimeChange"
        />
        <div class="filter-actions">
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>

      <el-table :data="list" style="width: 100%" border stripe v-loading="loading">
        <el-table-column label="登录时间" min-width="160" align="center">
          <template slot-scope="{ row }">
            {{ formatTime(row.created_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="IP" min-width="130" align="center" />
        <el-table-column prop="phone_id" label="设备ID" min-width="140" align="center" />
        <el-table-column prop="session_id" label="会话ID" min-width="140" align="center" />
        <el-table-column prop="channel_id" label="渠道ID" width="100" align="center" />
        <el-table-column prop="phone_model" label="手机型号" min-width="120" align="center" />
        <el-table-column prop="phone_manufacturer" label="品牌" min-width="120" align="center" />
        <el-table-column prop="phone_version" label="系统版本" min-width="100" align="center" />
        <el-table-column prop="sdk_version" label="SDK" width="90" align="center" />
        <el-table-column prop="phone_network_name" label="网络" min-width="120" align="center" />
        <el-table-column prop="network_type" label="网络类型" width="100" align="center" />
        <el-table-column prop="oaid" label="OAID" min-width="140" align="center" />
        <el-table-column prop="imei" label="IMEI" min-width="140" align="center" />
        <el-table-column prop="pseudo_id" label="Pseudo ID" min-width="140" align="center" />
        <el-table-column prop="gui_id" label="GUI ID" min-width="140" align="center" />
        <el-table-column label="经纬度" min-width="150" align="center">
          <template slot-scope="{ row }">
            {{ `${row.longitude || "--"}, ${row.latitude || "--"}` }}
          </template>
        </el-table-column>
        <el-table-column label="地址" min-width="220" align="center">
          <template slot-scope="{ row }">
            {{ [row.province, row.city, row.area, row.street, row.address].filter(Boolean).join(" ") || "--" }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryForm.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      loading: false,
      total: 0,
      summary: {},
      timeRange: [],
      queryForm: {
        id: "",
        page: 1,
        page_size: 10,
        ip: "",
        phone_id: "",
        oaid: "",
        channel_id: "",
        start_time: "",
        end_time: "",
      },
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const data = await this.$api.getUser.getUserLoginList(this.queryForm);
        this.total = data.data && data.data.count ? data.data.count : 0;
        this.summary = data.data && data.data.summary ? data.data.summary : {};
        this.list = data.data && data.data.list ? data.data.list : [];
      } finally {
        this.loading = false;
      }
    },
    open(id) {
      this.queryForm = {
        id,
        page: 1,
        page_size: 10,
        ip: "",
        phone_id: "",
        oaid: "",
        channel_id: "",
        start_time: "",
        end_time: "",
      };
      this.timeRange = [];
      this.getList();
      this.dialogVisible = true;
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.queryForm.page_size = size;
      this.queryForm.page = 1;
      this.getList();
    },
    handleTimeChange(value) {
      if (!value) {
        this.queryForm.start_time = "";
        this.queryForm.end_time = "";
        return;
      }
      this.queryForm.start_time = Math.floor(Number(value[0]) / 1000);
      this.queryForm.end_time = Math.floor(Number(value[1]) / 1000);
    },
    search() {
      this.queryForm.page = 1;
      this.getList();
    },
    resetSearch() {
      const id = this.queryForm.id;
      this.queryForm = {
        id,
        page: 1,
        page_size: 10,
        ip: "",
        phone_id: "",
        oaid: "",
        channel_id: "",
        start_time: "",
        end_time: "",
      };
      this.timeRange = [];
      this.getList();
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
  },
};
</script>

<style scoped>
.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.summary-item {
  padding: 10px 12px;
  border-radius: 10px;
  background: #f7faff;
  border: 1px solid #e5edf8;
  color: #47648f;
}

.filter-grid {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  align-items: center;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}
</style>
